import { useState } from "react";
import { MutationOptions } from "@apollo/client";
import { create, show, useModal } from "@ebay/nice-modal-react";

import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import Textarea from "ds/components/Textarea";
import Typography from "ds/components/Typography";

import useCancelScanRun, { ScanRunForCancel } from "../useCancelScanRun";

type CancelScanRunModalProps = {
  scanRun: ScanRunForCancel;
  refetchQueries?: MutationOptions["refetchQueries"];
};

const CancelScanRunModal = create(function CancelScanRunModal({
  scanRun,
  refetchQueries,
}: CancelScanRunModalProps) {
  const modal = useModal();
  const [note, setNote] = useState("");
  const { cancel, isCanceling } = useCancelScanRun({ scanRun, refetchQueries });

  const handleConfirm = () => {
    cancel(note).then(() => modal.hide());
  };

  return (
    <DeleteConfirmationModal
      title="Cancel scan run"
      confirmationButtonLabel="Cancel scan run"
      onConfirm={handleConfirm}
      isLoading={isCanceling}
      isDismissable={!isCanceling}
    >
      <ConfirmationModalMessage>
        <Typography tag="div">Are you sure you want to cancel this scan run?</Typography>
        <Typography tag="div" margin="x-large 0">
          If yes, you can leave an optional note explaining why
        </Typography>
        <Textarea value={note} onChange={(e) => setNote(e.target.value)} />
      </ConfirmationModalMessage>
    </DeleteConfirmationModal>
  );
});

export const showCancelScanRunModal = (props: CancelScanRunModalProps) =>
  show(CancelScanRunModal, props);
